import React, { Component } from "react"
import Home from "../components/templates/Home"
import { Grid } from "@material-ui/core"
import SEO from "../components/molecules/seo"

export default function IndexPage() {
  return (
    <>
      <SEO
        title="Home"
        keywords={[
          `片平ゼミ`,
          `片平`,
          `ゼミ`,
          `東京大学`,
          `経済学部`,
          `ブランド`,
          `丸の内`,
          `自主ゼミ`,
        ]}
      />
      <Home />
    </>
  )
}
